import React from "react";
import { observer } from "mobx-react";
import { MusicalGenreUpdateStore } from "../../store";
import { MusicalGenreUpdateForm } from "./MusicalGenreUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type MusicalGenreUpdateProps = {
  musicalGenreUpdateStore: MusicalGenreUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const MusicalGenreUpdate: React.FC<MusicalGenreUpdateProps> = observer(
  ({ musicalGenreUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={musicalGenreUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={musicalGenreUpdateStore.savedButOutdated}
          onReload={() => musicalGenreUpdateStore.reloadMusicalGenre()}
          reloadDisabled={musicalGenreUpdateStore.isProcessing}
        />
        <MusicalGenreUpdateForm
          musicalGenreUpdateStore={musicalGenreUpdateStore}
          nameError={musicalGenreUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            musicalGenreUpdateStore.setNameValue(value);
          }}
          name={musicalGenreUpdateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={musicalGenreUpdateStore.saveDisabled}
          onSave={() => musicalGenreUpdateStore.saveMusicalGenre()}
          onCancel={() => musicalGenreUpdateStore.cancelMusicalGenre()}
        />
        <ErrorDialog
          open={musicalGenreUpdateStore.errorDialogOpened}
          title={musicalGenreUpdateStore.errorTitle}
          description={musicalGenreUpdateStore.errorDescription}
          onClose={() => musicalGenreUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={musicalGenreUpdateStore.confirmDialogOpened}
          title={musicalGenreUpdateStore.confirmDialogTitle}
          description={musicalGenreUpdateStore.confirmDialogDescription}
          onConfirm={() => musicalGenreUpdateStore.executeConfirmedAction()}
          onCancel={() => musicalGenreUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
